import { Row, Col } from "react-bootstrap";
import { useSharedSafariContext } from "provider/ShareSafariProvider";

const StepForm6 = () => {
  const { organizeSafari, sharedSafariDispatch } = useSharedSafariContext();

  return (
    <Row className="pt-3">
      {/* Mobile Number and Change option */}
      {/* <Col xs={12} className="mb-3 text-center">
        <label className="Modal_label text-center">Mobile Number Verification</label>
        <p className="font_colorfomr px-lg-5">
          We will send you a One Time Passcode on this Mobile Number
        </p>
        <label className="Modal_label text-center">
          +91-{organizeSafari?.mobile_number || "__________"}{" "}
          <button
            className="changebtn ms-2"
            type="button"
            onClick={() => {
              sharedSafariDispatch({
                type: "ORGANIZE_SF_SET_STEP",
                payload: 4,
              });
            }}
          >
            Change
          </button>
        </label>
      </Col> */}

      {/* Confirmation message */}
      {/* <Col xs={12} className="mb-3 text-center mt-4">
        <h3 className="mb-0" style={{ fontStyle: "italic" }}>Thank you</h3>
        <p style={{ fontStyle: "italic" }}>
          Your OTP has been verified successfully.
        </p>
      </Col> */}
    </Row>
  );
};

export default StepForm6;
